import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getStatusClassName } from './configStructure'

import './Badge.scss';

const Badge = ({ badgeType, square, reversed, children, info, caseStatus, extraClass, style, isMerchantPortal, spanClass }) => {
  const badgeClass = getStatusClassName(badgeType);
  const acquirerCode=JSON.parse(sessionStorage.getItem("state")).auth.user.acquirerCode;
  const wrapperClass = classnames(spanClass ? spanClass : 'badge', {
    [`badge-${badgeClass} ${acquirerCode}`]: badgeClass,
    'badge-square': square,
    'badge-reversed': reversed,
    'badge-info': info,
    'badge-case-status': caseStatus,
    [extraClass]: extraClass,
  });

  return (
    <span
      style={style}
      className={wrapperClass}
    >
      {children}
    </span>
  );
};

Badge.propTypes = {
  badgeType: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.string,
  ]).isRequired,
  square: PropTypes.bool,
  reversed: PropTypes.bool,
  info: PropTypes.bool,
  extraClass: PropTypes.string,
  style: PropTypes.func,
  spanClass: PropTypes.string,
};

Badge.defaultProps = {
  square: false,
  reversed: false,
  info: false,
  extraClass: '',
  spanClass: '',
};

export default Badge;
